export default __webpack_public_path__ + "static/media/b4.81577fb4.png";